import * as actiontypes from '../../constants/actionType';

export function setSelectedLabwareID(labwareID) {
  return (dispatch) => {
    dispatch({type: actiontypes.SET_SELECTED_LABWAREID, id: labwareID});
  };
}

export function setCurrentTipVolume(volume) {
  return {type: actiontypes.SET_CURRENT_TIP_VOLUME, volume};
}

export function setSelectedTipChannel(tipChannel) {
  return {type: actiontypes.SET_SELECTED_TIP_CHANNEL, tipChannel};
}

export function setCustomTipCount(data) {
  return {type: actiontypes.SET_CUSTOM_TIP_COUNT, data};
}

export function setSelectedMenu(data) {
  return {type: actiontypes.SET_SELECTED_MENU, data};
}

export function setSerialDilutionStep(data) {
  return {type: actiontypes.SET_SERIAL_DILUTION_STEP, data};
}

export function setSerialDilutionEditStep(data) {
  return {type: actiontypes.SET_SERIAL_DILUTION_EDIT_STEP, data};
}

export function setSerialDilutionPrevStep(data) {
  return {type: actiontypes.SET_SERIAL_DILUTION_PREV_STEP, data};
}

export function setSerialDilutionAllSample(data) {
  return {type: actiontypes.SET_SERIAL_DILUTION_SET_ALL_SAMPLE, data};
}

export function setOpenSdPreview(data) {
  return {type: actiontypes.SET_OPEN_SD_PREVIEW, data};
}

export function setBroadcastTaskEditStep(data) {
  return {type: actiontypes.SET_BROADCAST_TASK_EDIT_STEP, data};
}

export function resetProtocolEditorState() {
  return {type: actiontypes.RESET_PROTOCOL_EDITOR_STATE};
}

export function restoreProtocolEditorState(state) {
  return {type: actiontypes.RESTORE_PROTOCOL_EDITOR_STATE, state};
}

export function setPoolingTaskStep(data) {
  return {type: actiontypes.SET_POOLING_TASK_STEP, data};
}

export function setPoolingTaskEditStep(data) {
  return {type: actiontypes.SET_POOLING_TASK_EDIT_STEP, data};
}

export function setCurrentTipVolumeNextState(data) {
  return {type: actiontypes.SET_CURRENT_TIP_VOLUME_NEXT_STATE, data};
}

export function setCurrentTipVolumePrevState(data) {
  return {type: actiontypes.SET_CURRENT_TIP_VOLUME_PREV_STATE, data};
}

export function setNormalizationTaskEditStep(data) {
  return {type: actiontypes.SET_NORMALIZATION_TASK_EDIT_STEP, data};
}

export function setIsEditMixing(data) {
  return {type: actiontypes.SET_IS_EDIT_MIXING, data};
}

export function setVolumeModalOpen(data) {
  return {type: actiontypes.SET_VOLUME_MODAL_OPEN, data};
}

export function setADModalShown(data) {
  return {type: actiontypes.SET_ASPIRATE_DISPENSE_MODAL_SHOWN, data};
}

export function setCopiedPipettingParameter(data) {
  return {type: actiontypes.SET_COPIED_PIPETTING_PARAMETER, data};
}

export function resetCopiedPipettingParameter() {
  return {type: actiontypes.RESET_COPIED_PIPETTING_PARAMETER};
}

export function setSimpleTransferEditedType(data) {
  return {type: actiontypes.SET_SIMPLE_TRANSFER_EDITED_TYPE, data};
}

export function setAutosaveEnabled() {
  return {type: actiontypes.ENABLE_AUTO_SAVE};
}

export function setAutosaveDisabled() {
  return {type: actiontypes.DISABLE_AUTO_SAVE};
}

export function setPendingSaveExistStatus(isExist) {
  return {type: actiontypes.SET_PENDING_SAVE_EXIST, isExist};
}
